// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const DeleteGoalDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-deletegoaldialogcontainer" */ "./DeleteGoalDialogContainer")).then((bundle)=>{
        return {
            default: bundle.DeleteGoalDialogContainer
        };
    });
export const LazyDeleteGoalDialogContainer = /*#__PURE__*/ lazy(DeleteGoalDialogContainerLazyLoader);
